
import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
// tslint:disable-next-line: no-floating-promises

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        react: {
            //  wait: true,
            useSuspense: true
        },
        interpolation: { escapeValue: false }, // React already does escaping
        lng: "en", // language to use
        fallbackLng: "en",
        defaultNS: "translation",
    });

export default i18n;